<i18n
  src="@/locales/views/agro_exporter/providers/producers/list_producers.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/producer.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/crop_field.yml" lang="yaml"></i18n>

<template>
  <bread-crumbs :labels="[module_name]" />
  <template v-if="load_data_general">
    <div class="mt-8 flex flex-row justify-between">
      <div class="panel-plain-label space-x-2">
        <badge-default
          :label="total + ' ' + $t('labels.total_number_producers')"
        />
        <badge-default
          :label="total_hectares + ' ' + $t('labels.total_hectares')"
        />
      </div>

      <div>
        <span class="space-actions" />
        <new-button
          @click.prevent="goToNewProducer"
          :label="$t('labels.new_producer_button')"
        />
      </div>
    </div>
    <div class="mt-2 flex flex-col">
      <div v-if="producers.length > 0" class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{
                      $t("model.producer.agro_exporter_producer.producer_code")
                    }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.producer.producer_code") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.producer.lastname") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.producer.name") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.producer.agro_exporter_producer.active") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.crop_field.hectares") }}
                  </th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="producer in producers"
                  :key="producer.id"
                >
                  <td
                    class="table-cell-main link"
                    @click.prevent="goToShowProducer(producer.id)"
                  >
                    {{ producer.agro_exporter_producer.producer_code }}
                  </td>
                  <td
                    class="table-cell link"
                    @click.prevent="goToShowProducer(producer.id)"
                  >
                    {{ producer.producer_code }}
                  </td>
                  <td class="table-cell">{{ producer.lastname }}</td>
                  <td class="table-cell">{{ producer.name }}</td>
                  <td class="table-cell">
                    <yes-no-label
                      :value="producer.agro_exporter_producer.active"
                    />
                  </td>
                  <td class="table-cell">
                    {{ producer.hectares }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <alert-warning
        class="mt-8"
        v-else
        :warning_data="{
          title: $t('labels.no_producers_found')
        }"
      />
    </div>
    <table-paginator
      v-model="current_page"
      :total_rows="total"
      :rows_per_page="rows_per_page"
    />
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/providers/producers/list_producers.js";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";
export default {
  name: "AEProvidersProducersListProducers",
  components: { TablePaginator },
  data() {
    return {
      load_data_general: false,
      producers: [],
      total: 0,
      total_hectares: 0,
      current_page: 1,
      rows_per_page: 20
    };
  },
  props: {
    agro_exporter_id: {
      required: true
    }
  },
  methods: {
    fetchData: async function () {
      await this.fetchProducers();
      this.load_data_general = true;
    },
    fetchProducers: async function () {
      const response = await Requester.fetchProducers(
        this.agro_exporter_id,
        this.current_page,
        this.rows_per_page
      );
      this.producers = response.data.producers;
      this.total = response.data.total;
      this.total_hectares = response.data.total_hectares;
    },
    goToNewProducer: function () {
      this.$router.push({
        name: this.routeName("new_producer"),
        params: {
          agro_exporter_id: this.agro_exporter_id
        }
      });
    },
    goToShowProducer: function (producer_id) {
      this.$router.push({
        name: this.routeName("show_producer"),
        params: {
          agro_exporter_id: this.agro_exporter_id,
          producer_id: producer_id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.fetchData())
    );
  }
};
</script>
